/*
 * Copyright © 2015-2021 Serenova, LLC. All rights reserved.
 */

import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm } from 'redux-form/immutable';
import QueueQueryLayoutForm from './layout';
import { formValidation } from '../validation';

import {
  getSelectedSubEntityId,
  isSubEntitySaving,
  userHasUpdatePermission,
} from '../../../../redux/modules/entities/selectors';
import {
  subEntityFormSubmission,
  getCurrentSubFormValueByFieldName,
  getCurrentFormValueByFieldName,
} from '../../../../redux/modules/form/selectors';
import {
  getQueueQueryFormInitialValues,
  getVersionsCountInSelectedQueue,
  getSelectedVersionQuerylevelCount,
  currentTenantSlas,
  getQueuesPageDependentEntities,
  getMatchmaker2Enabled,
} from '../../../../redux/modules/entities/queues/selectors';
import { setSelectedSubEntityId, convertQueueQueryObjToEdn } from '../../../../redux/modules/entities';

const QueuesSubEntityForm = compose(
  connect((state) => ({
    form: `queueQuery:${getSelectedSubEntityId(state)}`,
  })),
  reduxForm({
    onSubmit: subEntityFormSubmission,
    validate: formValidation,
    destroyOnUnmount: true,
  })
)(QueueQueryLayoutForm);

export function mapStateToProps(state) {
  return {
    basicQuery: getCurrentSubFormValueByFieldName(state, `queueQuery:${getSelectedSubEntityId(state)}`, 'basicQuery'),
    dependentEntities: getQueuesPageDependentEntities(state),
    initialValues: getQueueQueryFormInitialValues(state),
    isSaving: isSubEntitySaving(state),
    key: getSelectedSubEntityId(state),
    matchmaker2Enabled: getMatchmaker2Enabled(state),
    querylevelCountInSelectedVersion: getSelectedVersionQuerylevelCount(state),
    selectedQueueName: getCurrentFormValueByFieldName(state, 'name'),
    selectedSubEntityId: getSelectedSubEntityId(state),
    tenantSlas: currentTenantSlas(state) ? currentTenantSlas(state) : [],
    userHasUpdatePermission: userHasUpdatePermission(state),
    versionsCountInSelectedQueue: getVersionsCountInSelectedQueue(state),
  };
}

export const actions = {
  setSelectedSubEntityId,
  convertQueueQueryObjToEdn,
};

export default connect(mapStateToProps, actions)(QueuesSubEntityForm);
